<template>
  <v-container fluid pa-0>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="center" justify="center" no-gutters>
          <div class="pb-10 px-5">
            <div class="image-holder">
              <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%;">
                <v-slide-x-transition>
                  <v-row v-if="imageIsLoaded" align="center" class="fill-height" justify="center" no-gutters>
                    <img src="img/undraw_projections_re_ulc6.svg" style="height: 100%;"/>
                  </v-row>
                </v-slide-x-transition>
              </div>
            </div>
            <section-header class="mb-5 mt-5">
              <span v-html="$t('financials.no_duns_number')"></span>
            </section-header>
            <div class="text-body-2 text-sm-body-1"
                 v-html="$t('financials.how_to_get_duns_number')">
            </div>

            <template v-if="$hasMatchingTenantRoles(['tenant_admin'])">
              <v-form ref="form">
                <v-text-field v-model="dunsNumber"
                              :dense="$vuetify.breakpoint.xsOnly"
                              :label="$t('financials.type_your_duns_number')"
                              :rules="[$rules.required, $rules.dunsNumber]"
                              class="mt-8"
                              outlined>
                  <template v-slot:append-outer>
                    <v-btn v-if="$vuetify.breakpoint.smAndUp" :large="$vuetify.breakpoint.smAndUp" :loading="saving"
                           color="primary"
                           style="margin-top: -18px;"
                           @click="save">
                      {{ $t('save') }}
                    </v-btn>
                  </template>
                </v-text-field>
                <div class="text-body-2 mb-5">
                  <a @click="openTenantDetailsDialog">
                    <v-icon style="margin-top: -2px;">mdi mdi-magnify</v-icon>
                    {{ $t('financials.i_dont_know_my_duns_number') }}</a>
                </div>
              </v-form>

              <v-btn v-if="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.smAndUp" :loading="saving"
                     color="primary"
                     @click="save">
                {{ $t('save') }}
              </v-btn>
              <div class="caption primary--text text--darken-1 mt-2 mb-10 mt-sm-2">
                {{ $t('financials.after_you_have_entered_duns_number') }}
              </div>
            </template>

            <template v-else>
              <div class="text-body-2 text-sm-body-1 mt-5 mb-5 info--text">
                {{ $t('financials.contact_your_admin_to_add_duns_number') }}
              </div>
            </template>

            <div class="mt-4 text-body-2 text-sm-body-1 font-weight-bold" style="font-style: italic;">
              {{ $t('financials.duns_number_explained') }}
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <duns-search-dialog ref="dunsSearchDialog" @save="saveFromSearch"/>

    <img src="img/undraw_projections_re_ulc6.svg" style="display: none;" @load="imageIsLoaded = true"/>
  </v-container>
</template>

<script>
import SectionHeader from "@/components/SectionHeader";
import tenantApi from "@/api/tenant";
import DunsSearchDialog from "@/components/DunsSearchDialog";

export default {
  name: 'NoDunsNumber',
  components: {DunsSearchDialog, SectionHeader},
  props: ['tenant'],
  data() {
    return {
      iconDelayDone: false,
      dunsNumber: '',
      saving: false,
      imageIsLoaded: false,
    }
  },
  methods: {
    async saveFromSearch(sr) {
      if (sr?.organization?.duns) {
        this.dunsNumber = sr.organization.duns;
        return new Promise(resolve => {
          this.$nextTick(async () => {
            await this.save();
            resolve();
          });
        })
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        const tenant = {...this.tenant};
        tenant.dunsNumber = this.dunsNumber;
        await tenantApi.updateCurrentTenant(tenant);
        this.$showSuccessNotification(this.$t('tenants.organization_update_success'));
        this.$emit('duns-number-saved');
      } catch (err) {
        this.$handleApiError(err, this.$t('tenants.organization_update_failed'));
      }
      this.saving = false;
    },
    async openTenantDetailsDialog() {
      this.$refs.dunsSearchDialog.open(this.tenant);
    },

  },
  mounted() {
    setTimeout(() => {
      this.iconDelayDone = true;
    }, 100);
  }
};
</script>


<style lang="scss" scoped>
.image-holder {
  position: relative;
  margin: auto;
  width: 40vw;
  height: 40vw;
}

@media screen and (min-width: 600px) {
  .image-holder {
    width: 10vw;
    height: 10vw;
    margin: 0;
  }
}
</style>
